import React, {useEffect, useState} from 'react';
import './FactorPrint8cm.scss';
import commaSeparator from "../../../utils/CommaSeparator";

const FactorPrint8Cm = ({data}) => {

  const [headerAndFooter, setHeaderAndFooter] = useState({
    discount: "",
    servicesPrice: "",
    factorTotalPrice: "",
    shopMobile: "",
    shopEcId: "",
    shopSite: "",
    shopTelegram: "",
    shopInstagram: "",
    servicesTitle: "",
    shopAddress: "",
    shopTelephone: "",
    factorDate: "",
    totalProductPrice: "",
    shopProvince: "",
    shopCity: "",
    factorId: "",
    shopName: ""
  })

  useEffect(() => {

    const headers = {};
    const footer = {};

    if (data && data.headerAndFooter && data.headerAndFooter.header) {
      data.headerAndFooter.header.forEach((item) => {
        headers[item.staticKey] = item.value;
      });
    }

    if (data && data.headerAndFooter && data.headerAndFooter.footer) {

      data.headerAndFooter.footer.forEach((item) => {
        footer[item.staticKey] = item.value;
      });
    }

    setHeaderAndFooter({...footer, ...headers});
  }, [data]);

  const style = `  @media print {
    @page {
      size: portrait !important;
    }
  }`

  console.log(data)
  try {
    return (
      <div className={"main-8cm"}>
        <style>{style}</style>
        <div className={"one-8 border-class"}>
          {data?.headerAndFooter?.logo && <img src={data?.headerAndFooter?.logo} alt={"logo"}/>}
          <div className={"shop-name-side"}>
            <h4>{headerAndFooter?.shopName}</h4>
            <div className={"inline-text"}>
              <p>شمـاره فاکتـور : </p>
              <h6>{headerAndFooter?.factorId}</h6>
            </div>
            <div className={"inline-text"}>
              <p>تاریخ : </p>
              <h6>{headerAndFooter?.factorDate}</h6>
            </div>
          </div>
        </div>

        <div className={"table-8 border-class"}>

          <ul className={"head"}>
            <li style={{gridColumn: "1/-1"}}>نام کالا</li>
            <li>تعداد</li>
            <li>قیمت فروش</li>
            <li>تخفیف</li>
            <li>قابل پرداخت</li>
          </ul>
          {data.data[0].data.map((v) =>
            <ul className={"body"}>
              <li style={{gridColumn: "1/-1", justifyContent: "flex-start"}}>{v.NKALA}</li>
              <li>{v?.TE}</li>
              <li>{commaSeparator(v?.GHVAHED)}</li>
              <li>{commaSeparator(v?.OFFKALA)}</li>
              <li>{commaSeparator((+v.GHVAHED * +v?.TE) - (+v?.OFFKALA * +v?.TE))}</li>
            </ul>
          )}
        </div>

        <div className={"sum-side"}>
          <div className={"inline-text"}>
            <p>جمع اقلام </p>
            <h6>{data.data[0].data.reduce((sum, item) => sum + +item.TE, 0)}</h6>
          </div>
          <div className={"inline-text"}>
            <p>جمع کل قبل از تخفیف</p>
            <h6>{commaSeparator(data.data[0].data.reduce((sum, item) => sum + +item.TE * item?.GHVAHED, 0))}</h6>
          </div>
          {+headerAndFooter?.discount !== 0 &&
            <div className={"inline-text"}>
              <p>سود شما از این خرید</p>
              <h6>{commaSeparator(headerAndFooter?.discount)}</h6>
            </div>
          }
          {+headerAndFooter?.servicesPrice !== 0 &&
            <div className={"inline-text"}>
              <p>مبلغ خدمات</p>
              <h6>{commaSeparator(headerAndFooter?.servicesPrice)}</h6>
            </div>
          }
          <div className={"inline-text price-total"}>
            <p>جمع کل </p>
            <h6 style={{fontSize: '14px'}}>{commaSeparator(headerAndFooter?.factorTotalPrice)}</h6>
          </div>
        </div>

        <div className={"address-8 border-class"}>
          <div className={"inline-text"} style={{alignItems: 'flex-start'}}>
            <p>آدرس </p>
            <p>:</p>
            <p>{headerAndFooter?.shopAddress}</p>
          </div>
          <div className={"inline-text"}>
            <p>شماره تماس : </p>
            <h6>{headerAndFooter?.shopMobile}</h6>
          </div>
        </div>

        {data?.textUnderPrint !== "" &&
          <div className={"textUnderPrint"}>
            <p>{data?.textUnderPrint}</p>
          </div>
        }

      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(FactorPrint8Cm);